"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (password) {
    return (/^[ -~]{6,25}$/.test(password)
    );
};